import request from 'utils/request'
import { stringify } from 'qs'

export function getRolePermissionByRoleId(param) {
  return request({
    url: '/api/rolePermission/' + param,
    method: 'get'
  })
}
export function getRolePermissionList(param) {
  return request({
    url: '/api/rolePermission/?pageSize=' + param.pageSize + '&pageNo=' + param.pageNo,
    method: 'get'
  })
}